import { supabase } from '../client';
import type { ActivityEntity, ActivityAction } from '@core/enums';

export interface ActivityPayload {
  from_status?: string;
  to_status?: string;
  application_id?: string;
  candidate_id?: string;
  job_id?: string;
  client_id?: string;
  thread_id?: string;
  [key: string]: unknown;
}

export const activityService = {
  /** Log an activity — fire-and-forget, never throws */
  async log(
    orgId: string,
    entity: ActivityEntity,
    action: ActivityAction,
    opts: {
      entityId?: string;
      actorId?: string | null;
      actorKeycloak?: string | null;
      payload?: ActivityPayload;
    } = {}
  ): Promise<void> {
    try {
      await supabase.from('ggj_b2b_activities').insert({
        org_id: orgId,
        entity,
        entity_id: opts.entityId ?? null,
        action,
        actor_id: opts.actorId ?? null,
        actor_keycloak: opts.actorKeycloak ?? null,
        payload: opts.payload ?? null,
      });
    } catch {
      // Silent — never block main flow
    }
  },

  /** Get recent activities for org (for Activity Feed) */
  async listByOrg(
    orgId: string,
    opts?: {
      limit?: number;
      actorId?: string;
      entity?: ActivityEntity;
      since?: string;
      action?: ActivityAction;
      /** ISO timestamp — return rows strictly older than this (for paging / load-more). */
      before?: string;
    }
  ) {
    let query = supabase
      .from('ggj_b2b_activities')
      .select(`
        id, entity, entity_id, action, payload, created_at,
        actor:ggj_b2b_org_users!actor_id(display_name)
      `)
      .eq('org_id', orgId)
      .order('created_at', { ascending: false })
      .limit(opts?.limit ?? 100);

    if (opts?.actorId) query = query.eq('actor_id', opts.actorId);
    if (opts?.entity) query = query.eq('entity', opts.entity);
    if (opts?.action) query = query.eq('action', opts.action);
    if (opts?.since) query = query.gte('created_at', opts.since);
    if (opts?.before) query = query.lt('created_at', opts.before);

    const { data, error } = await query;
    if (error) throw error;
    return data ?? [];
  },
};
